import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Badge,
  Row,
  Col,
  Avatar,
  // message,
  Modal,
  // Result,
  Spin,
} from "antd";
import {
  ArrowLeftIcon,
  CouponCart,
  DeleteIcon,
  LocationIcon,
  MoreIcon,
} from "../asset/icons/icons";
import { WalletOutlined } from "@ant-design/icons";
import Table from "react-bootstrap/Table";
import EmptyCart from "../asset/EmptyCart.svg";
import opayimg from "../asset/opayimg.png";
import { useDispatch, useSelector } from "react-redux";
import {
  createOpayPayment,
  deleteItemsInCart,
  getAllAvailableLocation,
  getItemsInCart,
  postVerifyTransaction,
  updateItemsInCart,
} from "../redux/Actions";
import { getCartReducer } from "../redux/Reducer/cartReducer";
import { getPaymentReducer } from "../redux/Reducer/paymentReducer";
import { getUserWallet } from "../redux/Actions/walletAction";
import { getWalletReducer } from "../redux/Reducer/walletReducer";
import ChangeOrderLocationModal from "./changeOrderLocation";
import VerifyAccountModal from "./VerifyAccountModal";
import PayStackButtonMethod from "./paystackButtonMethod";
import SearchableNumberSelect from "./UI/InputFields/SearchableNumberSelect";

const NewCart = ({
  initialCartItems,
  authuserdetails,
  handleVerifyStatus,
  userProfileDetails,
  setSelectedKey,
  onClose,
  setOpen,
  setConfettiActive,
}) => {
  const [modal2Open, setModal2Open] = useState(false);
  const [locationDetails, setLocationDetails] = useState("");
  const [isLoadingPayment, setIsLoadingPayment] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  // const [isFlutterModalOpen, setIsFlutterModalOpen] = useState(false);

  const {
    verifyTransaction,
    availableLocations,
    isloadingAvailableLocations,
    isloadingverifyTransaction,
    isloadingUpdatedCartItem,
    isloadingCartItems,
  } = useSelector(getCartReducer);

  const { paymentLoading } = useSelector(getPaymentReducer);

  const { walletData, isLoadingWallet } = useSelector(getWalletReducer);
  const walletBalance = parseFloat(walletData?.wallet?.balance || 0);

  const dispatch = useDispatch();

  const [cartItems, setCartItems] = useState(initialCartItems || []);
  const [latestUpdatedCartItem, setLatestUpdatedCartItem] = useState({
    id: "",
    qty: "",
  });

  const [subtotal, setSubtotal] = useState(0);
  const [totalCost, setTotalCost] = useState(0);
  const [isOrderButtonDisabled, setIsOrderButtonDisabled] = useState(true);

  useEffect(() => {
    if (authuserdetails?.id) {
      dispatch(getUserWallet(authuserdetails.id));
    }
  }, [dispatch, authuserdetails]);

  const FormatNumber = (number) => {
    return new Intl.NumberFormat("en-NG", {
      style: "currency",
      currency: "NGN",
    }).format(number);
  };

  // 👉 SAFER PROMO DATE LOGIC
  const isPromoActive = (product) => {
    if (product?.is_promo_product !== 1 && product?.is_promo_product !== true)
      return false;

    // If no dates are set, treat as permanent promo
    if (!product.start_date && !product.end_date) return true;

    const now = new Date().getTime();
    const start = product.start_date
      ? new Date(product.start_date).getTime()
      : 0;
    const end = product.end_date
      ? new Date(product.end_date).setHours(23, 59, 59, 999)
      : Infinity;

    return now >= start && now <= end;
  };

  const calculateItemPrice = (item) => {
    const product = item?.product;
    if (!product) return 0;

    const qty = Number(item?.qty) || 0;
    const standardTotal = (Number(product?.amount) || 0) * qty;

    if (isPromoActive(product)) {
      const promoAmount = Number(product.promo_amount) || 0;
      // 👉 FIX: Since qty is now the bundle count (e.g., 1), just multiply directly
      return qty * promoAmount;
    }

    return standardTotal;
  };

  const isItemDiscounted = (item) => {
    const standardTotal =
      (Number(item?.product?.amount) || 0) * (Number(item?.qty) || 0);
    const calculatedTotal = calculateItemPrice(item);
    return calculatedTotal < standardTotal;
  };

  // 👉 REWRITTEN CALCULATION & VALIDATION LOGIC
  const calculateTotals = () => {
    let netTotal = 0;
    let newTotalQuantity = 0;
    let hasPromoItem = false;

    (cartItems || []).forEach((item) => {
      const qty = Number(item?.qty) || 0;
      newTotalQuantity += qty;

      if (isPromoActive(item?.product)) {
        hasPromoItem = true;
      }

      netTotal += calculateItemPrice(item);
    });

    setSubtotal(netTotal);
    setTotalCost(netTotal);

    // Disable logic
    let shouldDisable = false;

    if (cartItems.length === 0) {
      shouldDisable = true;
    } else if (userProfileDetails?.data?.user_type_id !== 5) {
      // IF THEY DON'T HAVE A PROMO ITEM, ENFORCE THE 50 LIMIT
      if (!hasPromoItem && newTotalQuantity < 50) {
        shouldDisable = true;
      }
    }

    setIsOrderButtonDisabled(shouldDisable);
  };

  // Handles updating backend with correct bundle sizes
  const handleQuantityChange = (value, itemId) => {
    const targetItem = cartItems?.find((item) => item.id === itemId);
    const isPromo = targetItem ? isPromoActive(targetItem.product) : false;

    const uiQty = parseInt(value) || 0;

    // Send backend "1" if it's a promo bundle, else send exact qty
    let backendQty = uiQty;
    if (isPromo && targetItem?.product?.unit) {
      backendQty = uiQty / Number(targetItem.product.unit);
    }

    const updatedCartItems = cartItems?.map((item) =>
      item?.id === itemId ? { ...item, qty: uiQty } : item,
    );

    setLatestUpdatedCartItem({
      id: itemId,
      qty: backendQty,
    });

    dispatch(updateItemsInCart(itemId, { qty: backendQty }));
    setCartItems(updatedCartItems);
  };

  const handleDeleteItem = (itemId) => {
    const updatedCartItems = cartItems?.filter((item) => item?.id !== itemId);
    dispatch(deleteItemsInCart(itemId));
    setCartItems(updatedCartItems);
  };

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setSelectedKey("6");
    setIsModalOpen(false);
    setOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  // const handleFlutterOk = () => {
  //   setIsFlutterModalOpen(false);
  // };
  // const handleFlutterCancel = () => {
  //   setIsFlutterModalOpen(false);
  // };

  const handleChangeLocation = () => {
    setModal2Open(true);
    dispatch(getAllAvailableLocation());
  };

  const handleLocationChange = (locationid, locationname) => {
    setLocationDetails({
      ...locationDetails,
      location_id: locationid,
      location_name: locationname,
    });
    setModal2Open(false);
  };

  const newOpayConfig = {
    platform: "web",
    amount: totalCost,
    location_id:
      userProfileDetails?.data?.location?.id || locationDetails?.location_id,
    is_direct: userProfileDetails?.data?.user_type_id === 5 ? true : false,
    payment_channel: "opay",
  };

  // Wallet Checkout logic
  const handleWalletPayment = () => {
    if (walletBalance < totalCost) {
      Modal.warning({
        title: "Insufficient Wallet Balance",
        content: `Your wallet balance (${FormatNumber(walletBalance)}) is less than the total cost (${FormatNumber(totalCost)}). Please fund your wallet or choose another payment method.`,
        okText: "Got it",
      });
      return;
    }

    Modal.confirm({
      title: "Confirm Wallet Payment",
      content: `Are you sure you want to pay ${FormatNumber(totalCost)} using your wallet balance?`,
      okText: "Yes, Pay",
      cancelText: "Cancel",
      onOk() {
        setIsLoadingPayment(true);
        if (latestUpdatedCartItem.id !== "") {
          dispatch(
            updateItemsInCart(latestUpdatedCartItem?.id, {
              qty: parseInt(latestUpdatedCartItem?.qty) || 0,
            }),
          );
        }

        dispatch(
          postVerifyTransaction({
            reference: `WAL_${Date.now()}`,
            transaction_id:
              Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000,
            location_id:
              locationDetails === ""
                ? userProfileDetails?.data?.location?.id
                : locationDetails?.location_id,
            is_direct:
              userProfileDetails?.data?.user_type_id === 5 ? true : false,
            is_wallet_payment: true,
            amount: totalCost, // Passes calculated total to backend
          }),
        );
      },
    });
  };

  const handlePlaceOrderDist = (value) => {
    dispatch(
      postVerifyTransaction({
        reference: `NB${Date.now()}`,
        transaction_id:
          Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000,
        location_id:
          locationDetails === ""
            ? userProfileDetails?.data?.location?.id
            : locationDetails?.location_id,
        is_direct: userProfileDetails?.data?.user_type_id === 5 ? true : false,
      }),
    );
    if (latestUpdatedCartItem.id !== "") {
      dispatch(
        updateItemsInCart(latestUpdatedCartItem?.id, {
          qty: parseInt(latestUpdatedCartItem?.qty) || 0,
        }),
      );
    }
    setIsLoadingPayment(true);
  };

  const handleOpayPayment = (value) => {
    setIsLoadingPayment(paymentLoading);
    if (latestUpdatedCartItem.id !== "") {
      dispatch(
        updateItemsInCart(latestUpdatedCartItem?.id, {
          qty: parseInt(latestUpdatedCartItem?.qty) || 0,
        }),
      );
    }
    dispatch(createOpayPayment(newOpayConfig));
  };

  useEffect(() => {
    setCartItems(initialCartItems ?? []);
  }, [initialCartItems]);

  useEffect(() => {
    if (cartItems && cartItems.length > 0) {
      calculateTotals();
    } else {
      setSubtotal(0);
      setTotalCost(0);
      setIsOrderButtonDisabled(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartItems]);

  useEffect(() => {
    if (verifyTransaction?.status === true) {
      dispatch(getItemsInCart(authuserdetails.id));
      dispatch(getUserWallet(authuserdetails.id));
      onClose();
      setConfettiActive(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [verifyTransaction]);

  // Consolidate disabled check to clean up the JSX
  const buttonsDisabled =
    isOrderButtonDisabled ||
    isLoadingPayment ||
    isloadingUpdatedCartItem ||
    isloadingverifyTransaction;

  return (
    <Card>
      <div className="dashboardcardpriceandcartdiv">
        <p
          className="typography"
          style={{ fontSize: "18px", fontWeight: "500", color: "#1A202C" }}
        >
          My Cart
        </p>
        <Button
          type="text"
          style={{ margin: "-1.5em 0px 0px 0px", padding: "0px" }}
        >
          <MoreIcon />
        </Button>
      </div>

      <Spin spinning={isloadingCartItems} tip="Loading Cart">
        {cartItems?.code !== "ERR_BAD_REQUEST" ? (
          cartItems?.length !== 0 ? (
            <div className="">
              <Badge size="small" count={cartItems?.length} color="#BDC167">
                <p
                  className="typography"
                  style={{
                    color: "#252A4D",
                    fontWeight: 500,
                    fontSize: "16px",
                  }}
                >
                  Orders
                </p>
              </Badge>
              <Row>
                <Col span={24}>
                  <Table responsive borderless size="sm">
                    <thead>
                      <tr>
                        <th className="cart-table-header-style">Item</th>
                        <th className="cart-table-header-style">Qty</th>
                        <th className="cart-table-header-style">Price</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {cartItems?.length !== 0
                        ? cartItems?.map((item, i) => {
                            const isDiscounted = isItemDiscounted(item);
                            const isPromo = isPromoActive(item?.product);

                            return (
                              <tr key={item.id}>
                                <td>
                                  <div className="d-flex align-items-center gap-1">
                                    <div>
                                      <Avatar
                                        size="medium"
                                        icon={
                                          <img
                                            src={item?.product?.images[0]?.url}
                                            alt="carticonimage1"
                                            draggable={false}
                                          />
                                        }
                                      />
                                    </div>
                                    <div>
                                      <p className="typography carttextproductnametypography">
                                        {item?.product?.name}
                                        {isDiscounted && (
                                          <span
                                            style={{
                                              fontSize: "10px",
                                              color: "#BDC167",
                                              marginLeft: "5px",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            (Promo Deal)
                                          </span>
                                        )}
                                      </p>
                                      <p className="typography carttextproductpricetypography">
                                        {!isDiscounted &&
                                          FormatNumber(item?.product?.amount)}
                                      </p>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <SearchableNumberSelect
                                      value={item?.qty}
                                      onChange={(val) =>
                                        handleQuantityChange(val, item?.id)
                                      }
                                      allowClear={!isPromo}
                                      disabled={isPromo} // LOCK QTY IF PROMO
                                    />
                                  </div>
                                </td>
                                <td>
                                  <div className="dashboardcardpriceandcartdiv">
                                    <p
                                      className="typography carttextproductQpricetypography"
                                      style={{
                                        color: isDiscounted
                                          ? "#D4AF37"
                                          : "inherit",
                                        fontWeight: isDiscounted
                                          ? "bold"
                                          : "normal",
                                      }}
                                    >
                                      {FormatNumber(calculateItemPrice(item))}
                                    </p>
                                  </div>
                                </td>
                                <td>
                                  <div className="dashboardcardpriceandcartdiv">
                                    <Button
                                      type="text"
                                      style={{
                                        margin: "0px",
                                        padding: "0px",
                                        height: "fit-content",
                                      }}
                                      onClick={() => handleDeleteItem(item?.id)}
                                    >
                                      <DeleteIcon />
                                    </Button>
                                  </div>
                                </td>
                              </tr>
                            );
                          })
                        : null}
                    </tbody>
                  </Table>
                </Col>
              </Row>

              <Row>
                <Col span={24}>
                  <div>
                    <p
                      className="typography"
                      style={{ fontWeight: 500, marginTop: "10px" }}
                    >
                      Nearest Pickup to you
                    </p>
                  </div>

                  <div className="dashboardcardpriceandcartdiv">
                    {locationDetails === "" ? (
                      <p className="cartnearestlocation">
                        <LocationIcon />
                        {`${userProfileDetails?.data?.location?.name} - ${userProfileDetails?.data?.location?.address}`}
                      </p>
                    ) : (
                      <p className="cartnearestlocation">
                        <LocationIcon />
                        {`${locationDetails?.location_name}`}
                      </p>
                    )}
                    <Button
                      size="small"
                      className="cartnearestlocationbutton"
                      onClick={handleChangeLocation}
                    >
                      Change
                    </Button>
                    <ChangeOrderLocationModal
                      modal2Open={modal2Open}
                      setModal2Open={setModal2Open}
                      availableLocations={availableLocations}
                      isloadingAvailableLocations={isloadingAvailableLocations}
                      handleLocationChange={handleLocationChange}
                      defaultsel={
                        locationDetails === ""
                          ? userProfileDetails?.data?.location?.id
                          : locationDetails?.location_id
                      }
                    />
                  </div>

                  <div>
                    <p className="typography cartpickingwhenready">
                      You will be picking up your order from this location once
                      it is ready.
                    </p>
                  </div>

                  {/* Warning message if disabled by limit */}
                  {isOrderButtonDisabled &&
                    cartItems.length > 0 &&
                    userProfileDetails?.data?.user_type_id !== 5 && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "10px",
                          textAlign: "center",
                        }}
                      >
                        You cannot place an order with less than 50 regular
                        items.
                      </div>
                    )}

                  <div style={{ marginTop: "1em" }}>
                    <div className="cartpricesummariesdiv">
                      <p className="cartpricesummariestypog1">Sub total</p>
                      <p className="typography">{FormatNumber(subtotal)}</p>
                    </div>

                    <div className="cartpricesummariesdiv">
                      <p className="cartpricesummariestypog1 cartprices-total-txt">
                        Total
                      </p>
                      <p className="typography cartprices-total-txt">
                        {FormatNumber(totalCost)}
                      </p>
                    </div>

                    {userProfileDetails?.data?.user_type_id === 5 ? (
                      <div className="mt-2">
                        <Button
                          block
                          size={"large"}
                          className="placeordercartbutton typography"
                          onClick={handlePlaceOrderDist}
                          disabled={buttonsDisabled}
                        >
                          Place Order
                        </Button>
                      </div>
                    ) : userProfileDetails?.data?.status === 1 ? (
                      <div>
                        <Spin spinning={isLoadingWallet} size="small">
                          <div
                            className="mt-3 mb-3 p-3 rounded"
                            style={{
                              backgroundColor: "#F8F9FD",
                              border: "1px solid #E0E2E7",
                            }}
                          >
                            <div className="d-flex justify-content-between align-items-center mb-3">
                              <span style={{ fontSize: "13px", color: "#555" }}>
                                Wallet Balance:
                              </span>
                              <span
                                style={{
                                  fontWeight: "bold",
                                  color:
                                    walletBalance >= totalCost
                                      ? "#52c41a"
                                      : "#ff4d4f",
                                  fontSize: "16px",
                                }}
                              >
                                {FormatNumber(walletBalance)}
                              </span>
                            </div>
                            {/* 👉 FIX: Dynamic styles to actually gray out the button when disabled */}
                            <Button
                              block
                              size={"large"}
                              className="typography"
                              onClick={handleWalletPayment}
                              disabled={buttonsDisabled}
                              style={{
                                backgroundColor: buttonsDisabled
                                  ? "#d9d9d9"
                                  : "#252A4D",
                                color: buttonsDisabled
                                  ? "rgba(0, 0, 0, 0.25)"
                                  : "#fff",
                                border: "none",
                                height: "45px",
                              }}
                              icon={<WalletOutlined />}
                            >
                              Pay with Wallet
                            </Button>
                          </div>
                        </Spin>

                        <div className="cartpricesummariesdiv">
                          <Button
                            block
                            size={"large"}
                            className="cartcouponbutton typography"
                          >
                            <div className="d-flex justify-content-between align-items-center w-100">
                              <div className="d-flex align-items-center gap-2">
                                <CouponCart
                                  style={{ backgroundColor: "#BDC167" }}
                                />
                                <div>
                                  <span style={{ marginLeft: "1em" }}>
                                    Have a coupon code?
                                  </span>
                                </div>
                              </div>
                              <div className="">
                                <ArrowLeftIcon />
                              </div>
                            </div>
                          </Button>
                        </div>

                        <div className="mt-2">
                          <Button
                            block
                            size={"large"}
                            className="placeordercartbutton typography"
                            onClick={handleOpayPayment}
                            disabled={buttonsDisabled}
                            icon={
                              <img
                                src={opayimg}
                                alt="Opay"
                                style={{ height: "2.7em" }}
                              />
                            }
                          >
                            Pay with Opay
                          </Button>
                        </div>

                        <div>
                          <PayStackButtonMethod
                            userProfileDetails={userProfileDetails}
                            setIsLoadingPayment={setIsLoadingPayment}
                            isLoadingPayment={isLoadingPayment}
                            isloadingUpdatedCartItem={isloadingUpdatedCartItem}
                            showModal={showModal}
                            authuserdetails={authuserdetails}
                            totalCost={totalCost}
                            isOrderButtonDisabled={isOrderButtonDisabled}
                            postVerifyTransaction={postVerifyTransaction}
                            dispatch={dispatch}
                            latestUpdatedCartItem={latestUpdatedCartItem}
                            locationDetails={
                              locationDetails === ""
                                ? userProfileDetails?.data?.location?.id
                                : locationDetails?.location_id
                            }
                          />
                        </div>
                      </div>
                    ) : (
                      <Button
                        block
                        size={"large"}
                        onClick={showModal}
                        style={{ fontSize: "13px", fontWeight: 400 }}
                        className="placeordercartbutton typography"
                      >
                        Verify your account to proceed with payment
                      </Button>
                    )}
                  </div>
                </Col>
              </Row>
            </div>
          ) : (
            <img
              src={EmptyCart}
              alt="no order history"
              style={{ width: "100%" }}
              draggable={false}
            />
          )
        ) : (
          <img
            src={EmptyCart}
            alt="no order history"
            style={{ width: "100%" }}
            draggable={false}
          />
        )}
        <VerifyAccountModal
          isModalOpen={isModalOpen}
          handleOk={handleOk}
          handleCancel={handleCancel}
        />
      </Spin>
    </Card>
  );
};
export default NewCart;
